import { Box, Typography } from '@mui/material';
import FileOutputLogTable from './components/FileOutputLogTable';
import { useSearchParams } from 'react-router-dom';

const FileOutputLogs = () => {
  const [searchParams] = useSearchParams();
  const dateCreatedBySystemStart = searchParams.get('dateCreatedBySystemStart');
  const dateCreatedBySystemEnd = searchParams.get('dateCreatedBySystemEnd');
  
  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
        <Typography variant="h4" gutterBottom>
          Output Logs
        </Typography>
      </Box>
      <FileOutputLogTable 
        initialFilter={
          dateCreatedBySystemStart || dateCreatedBySystemEnd
            ? {
                dateCreatedBySystemStart: dateCreatedBySystemStart || undefined,
                dateCreatedBySystemEnd: dateCreatedBySystemEnd || undefined
              }
            : undefined
        }
      />
    </Box>
  );
};

export default FileOutputLogs;
